module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumSB.2dbd391.eot";